import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ac694d74"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content" }
const _hoisted_2 = { class: "-mx-2" }
const _hoisted_3 = { class: "col-12 md:col-6 mt-0" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "flex font-normal mb-2" }, [
  /*#__PURE__*/_createTextVNode("オプション名 "),
  /*#__PURE__*/_createElementVNode("span", { class: "pl-1 text-red" }, "必須")
], -1))
const _hoisted_5 = {
  key: 0,
  class: "block p-error text-sm"
}
const _hoisted_6 = { class: "col-12 md:col-6 mt-3" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "flex font-normal" }, "オプション説明", -1))
const _hoisted_8 = { class: "text-gray-500 block" }
const _hoisted_9 = {
  key: 0,
  class: "block p-error text-sm"
}
const _hoisted_10 = { class: "col-12 md:col-6 mt-3" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { for: "postion-number" }, [
  /*#__PURE__*/_createTextVNode("順番"),
  /*#__PURE__*/_createElementVNode("small", { class: "red-required pl-2" }, "必須")
], -1))
const _hoisted_12 = {
  key: 0,
  class: "block p-error text-sm"
}
const _hoisted_13 = { class: "col-6 md:col-3 mt-3" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-2" }, [
  /*#__PURE__*/_createTextVNode("所要時間"),
  /*#__PURE__*/_createElementVNode("small", { class: "red-required pl-2" }, "必須")
], -1))
const _hoisted_15 = {
  key: 0,
  class: "block p-error text-sm"
}
const _hoisted_16 = { class: "field col-12 px-0 ml-2 mt-3" }
const _hoisted_17 = { class: "flex flex-wrap gap-3" }
const _hoisted_18 = { class: "radio-wrapper__custom" }
const _hoisted_19 = { class: "flex align-items-center cursor-pointer" }
const _hoisted_20 = {
  key: 0,
  class: "icon-lms icon-lms_rad-chosen radio-icon text-xl mr-2"
}
const _hoisted_21 = {
  key: 1,
  class: "icon-lms icon-lms_radio radio-icon text-xl mr-2"
}
const _hoisted_22 = { class: "radio-wrapper__custom" }
const _hoisted_23 = { class: "flex align-items-center cursor-pointer" }
const _hoisted_24 = {
  key: 0,
  class: "icon-lms icon-lms_rad-chosen radio-icon text-xl mr-2"
}
const _hoisted_25 = {
  key: 1,
  class: "icon-lms icon-lms_radio radio-icon text-xl mr-2"
}
const _hoisted_26 = { class: "col-6 md:col-2 mt-3" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "flex font-normal mb-2" }, [
  /*#__PURE__*/_createTextVNode("金額 "),
  /*#__PURE__*/_createElementVNode("span", { class: "pl-1 text-red" }, "必須")
], -1))
const _hoisted_28 = {
  key: 0,
  class: "block p-error text-sm"
}
const _hoisted_29 = { class: "col-12 md:col-6 flex justify-content-end mt-3" }

import { onUpdated, ref, reactive, computed, onBeforeMount, watch } from "vue";
import { get, set } from "@vueuse/core";
import InputNumber from "primevue/inputnumber";
import Toast from "primevue/toast";
import { useToast } from "primevue/usetoast";
import { ValidateError } from "async-validator";
import { useAsyncValidator } from "@vueuse/integrations/useAsyncValidator";
import { IMedicalOption } from "@/clinic/typings";
import Message from "@/clinic/components/atoms/CustomPrimeVue/Message.vue";
import RadioButton from "primevue/radiobutton";
import { MedicalOptionServices, ServiceTagService } from "@/clinic/services";
import { notityErrorMsg } from "@/clinic/utils/notify-utils";
import RouterConstants from "@/clinic/constants/router.constants";
import RouterUtils from "@/common/utils/router.util";
import { MedicalHourOptions, MedicalMinuteOptions } from "@/clinic/typings/enums/medical-option";
import rules from "./rules";
import * as _ from "lodash";


export default /*#__PURE__*/_defineComponent({
  __name: 'form',
  props: {
    clinicId: null,
    model: null
  },
  setup(__props: any) {

const props = __props as {
  clinicId: string;
  model: IMedicalOption;
};

const toast = useToast();
const pass = ref(false);
const errorFields = ref<{ [key: string]: ValidateError | ValidateError[] }>();
const errors = ref<ValidateError[]>([]);
const formObject = reactive({
  id: 0,
  clinicId: 0,
  name: "",
  description: "",
  timeUnit: 0,
  hourUnit: "00",
  minuteUnit: "00",
  unitPrice: 0,
  displayPrice: true,
  positionNumber: "0",
});

/**
 * プロパティを定義する。
 * @returns void
 */


/**
 * バリデーションを初期化する。
 * @returns ComputedRef<UseAsyncValidator>
 */
const initValidation = computed(() => {
  return useAsyncValidator(formObject, rules);
});

/**
 * バリデーションを実行する。
 * @returns Promise<boolean>
 **/
const validate = async () => {
  const { execute } = get(initValidation);
  const { pass: fPass, errorFields: fErrorFields, errors: fErrors } = await execute();

  set(pass, get(fPass));
  set(errorFields, get(fErrorFields));
  set(errors, get(fErrors));

  return fPass;
};

/**
 * 一覧に戦く処理を実行する。
 * @returns void
 */
const backToList = () => RouterUtils.goTo(RouterConstants.MEDICAL_OPTIONS_ROUTER_NAME);

/**
 * 所要時間を計算する。
 * @returns string
 */
const getTimeUnit = computed(() => {
  return (parseInt(formObject.hourUnit) * 60 + parseInt(formObject.minuteUnit)).toString();
});

/**
 * オプションを保存する。
 * @returns Promise<void>
 */
const saveMedicalOption = async () => {
  set(formObject, "timeUnit", get(getTimeUnit));
  if (!(await validate())) {
    return;
  }

  // 説明が空文字の場合、nullを設定
  const saveData = { ...formObject } as any;
  if (saveData.description?.trim() === "") {
    saveData.description = "";
  }

  await MedicalOptionServices.saveOption(
    saveData,
    () => {
      RouterUtils.goTo(RouterConstants.MEDICAL_OPTIONS_ROUTER_NAME);
    },
    (errors: any) => {
      notityErrorMsg(errors, toast);
    }
  );
};

/**
 * モデルを読み込む。
 * @returns Promise<void>
 */
const loadModel = async () => {
  const clinicInfo = (await props.clinicId) as unknown as string;
  formObject.clinicId = clinicInfo;
  if (!props.model.id || props.model.id == formObject.id) return;
  const {
    id,
    clinic_id: clinicId,
    name,
    description,
    time_unit: timeUnit,
    unit_price: unitPrice,
    display_price: displayPrice,
    position_number: positionNumber,
  } = props.model;
  const updateProps = {
    id,
    clinicId,
    name,
    description,
    timeUnit,
    unitPrice,
    displayPrice,
    positionNumber,
  };
  Object.assign(formObject, updateProps);
  if (formObject.timeUnit) {
    const calculatedHourValue = Math.floor(parseInt(formObject.timeUnit) / 60);
    const calculatedMinuteValue = parseInt(formObject.timeUnit) % 60;
    if (calculatedHourValue < 10) {
      set(formObject, "hourUnit", calculatedHourValue.toString().padStart(2, "0"));
    } else {
      set(formObject, "hourUnit", calculatedHourValue.toString());
    }
    if (calculatedMinuteValue === 0 || calculatedMinuteValue === 5) {
      set(formObject, "minuteUnit", calculatedMinuteValue.toString().padStart(2, "0"));
    } else {
      set(formObject, "minuteUnit", calculatedMinuteValue.toString());
    }
  }
};

/**
 * モデルを読み込む。
 * @returns Promise<void>
 */
onUpdated(async () => {
  await loadModel();
});

/**
 * フォームを読み込む。
 * @returns Promise<void>
 */
const loadForm = async () => await loadModel();

onBeforeMount(() => loadForm());

return (_ctx: any,_cache: any) => {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Textarea = _resolveComponent("Textarea")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("form", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_component_InputText, {
          class: _normalizeClass(["flex border-round-md", { 'p-invalid': errorFields.value?.name }]),
          placeholder: "オプションメニューを入れてください (20字)",
          modelValue: formObject.name,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formObject.name) = $event))
        }, null, 8, ["modelValue", "class"]),
        (errorFields.value?.name)
          ? (_openBlock(), _createElementBlock("small", _hoisted_5, _toDisplayString(_.head(errorFields.value.name)?.message), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createVNode(_component_Textarea, {
          class: _normalizeClass(["w-100 h-10rem mt-2", { 'p-invalid': errorFields.value?.description }]),
          modelValue: formObject.description,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formObject.description) = $event)),
          placeholder: "説明が入ります (150字)",
          rows: "5",
          cols: "30",
          maxlength: "150"
        }, null, 8, ["modelValue", "class"]),
        _createElementVNode("small", _hoisted_8, _toDisplayString(formObject.description?.length || 0) + "/150文字", 1),
        (errorFields.value?.description)
          ? (_openBlock(), _createElementBlock("small", _hoisted_9, _toDisplayString(_.head(errorFields.value.description)?.message), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_10, [
        _hoisted_11,
        _createVNode(_component_InputText, {
          modelValue: formObject.positionNumber,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formObject.positionNumber) = $event)),
          "aria-describedby": "time-unit-help",
          type: "number",
          size: "large",
          min: 0,
          name: "position_number",
          class: "w-2"
        }, null, 8, ["modelValue"]),
        (errorFields.value?.positionNumber)
          ? (_openBlock(), _createElementBlock("small", _hoisted_12, _toDisplayString(_.head(errorFields.value.positionNumber)?.message), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_13, [
        _hoisted_14,
        _createVNode(_component_Dropdown, {
          modelValue: formObject.hourUnit,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formObject.hourUnit) = $event)),
          options: _unref(MedicalHourOptions),
          optionLabel: "name",
          optionValue: "value",
          class: _normalizeClass(["mr-2 font-normal", { 'p-invalid': errorFields.value?.timeUnit }])
        }, null, 8, ["modelValue", "options", "class"]),
        _createTextVNode(" : "),
        _createVNode(_component_Dropdown, {
          modelValue: formObject.minuteUnit,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formObject.minuteUnit) = $event)),
          options: _unref(MedicalMinuteOptions),
          optionLabel: "name",
          optionValue: "value",
          class: _normalizeClass(["mr-2 ml-2 font-normal", { 'p-invalid': errorFields.value?.timeUnit }])
        }, null, 8, ["modelValue", "options", "class"]),
        (errorFields.value?.timeUnit)
          ? (_openBlock(), _createElementBlock("small", _hoisted_15, _toDisplayString(_.head(errorFields.value.timeUnit)?.message), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            _createVNode(_unref(RadioButton), {
              modelValue: formObject.displayPrice,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formObject.displayPrice) = $event)),
              inputId: "display-price",
              name: "display_price",
              value: true
            }, null, 8, ["modelValue"]),
            _createElementVNode("label", {
              for: "display-price",
              class: _normalizeClass({ 'text-orange': formObject.displayPrice }),
              onClick: _cache[6] || (_cache[6] = ($event: any) => (formObject.displayPrice = true))
            }, [
              _createElementVNode("div", _hoisted_19, [
                (formObject.displayPrice)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_20))
                  : (_openBlock(), _createElementBlock("span", _hoisted_21)),
                _createTextVNode(" 価格表示する ")
              ])
            ], 2)
          ]),
          _createElementVNode("div", _hoisted_22, [
            _createVNode(_unref(RadioButton), {
              modelValue: formObject.displayPrice,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formObject.displayPrice) = $event)),
              inputId: "hide-price",
              name: "display_price",
              value: false
            }, null, 8, ["modelValue"]),
            _createElementVNode("label", {
              for: "hide-price",
              class: _normalizeClass({ 'text-orange': !formObject.displayPrice }),
              onClick: _cache[8] || (_cache[8] = ($event: any) => (formObject.displayPrice = false))
            }, [
              _createElementVNode("div", _hoisted_23, [
                (!formObject.displayPrice)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_24))
                  : (_openBlock(), _createElementBlock("span", _hoisted_25)),
                _createTextVNode(" 価格表示しない ")
              ])
            ], 2)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_26, [
        _hoisted_27,
        _createVNode(_unref(InputNumber), {
          class: _normalizeClass(["flex border-round-md", { 'p-invalid': errorFields.value?.unitPrice }]),
          placeholder: "120",
          modelValue: formObject.unitPrice,
          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((formObject.unitPrice) = $event))
        }, null, 8, ["modelValue", "class"]),
        (errorFields.value?.unitPrice)
          ? (_openBlock(), _createElementBlock("small", _hoisted_28, _toDisplayString(_.head(errorFields.value.unitPrice)?.message), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_29, [
        _createVNode(_component_Button, {
          label: "キャンセル",
          class: "p-button-light btn-cancel mr-3",
          onClick: backToList
        }),
        _createVNode(_component_Button, {
          label: "保存する",
          onClick: saveMedicalOption
        })
      ])
    ]),
    _createVNode(_unref(Toast), { position: "top-center" })
  ]))
}
}

})